module.exports = {"enrollment.connection.status.connected":"Connected","enrollment.connection.status.pending":"Pending","enrollment.connection.status.none":"Not Ordered","enrollment.connection.status.expired":"Expired","enrollment.connection.status.revoked":"Revoked","enrollment.connection.status.disconnected":"Disconnected"}


//////////////////
// WEBPACK FOOTER
// ./src/bundles/en/enrollment.json
// module id = 9601
// module chunks = 25